import { metaAdapter } from '@/adapters/wiki/meta';
import {
  wikiPageHrefTypes,
  wikiPageRouteTypeNames,
} from '@/constants/wiki-page-types';

const countryAdapter = (data) => {
  const { hrefs, reference_image } = data;

  const hrefsArray = Object.entries(hrefs).map(([key, value]) => {
    return {
      key: wikiPageHrefTypes[key],
      type: wikiPageRouteTypeNames[key],
      value,
    };
  });

  return {
    id: data.id,
    slug: data.slug,
    title: data.title || '',
    href: data.href,
    hrefs: hrefsArray,
    countryId: data.country_id,
    referenceImage: reference_image
      ? {
          id: reference_image.id,
          original: reference_image.original,
        }
      : null,
  };
};

export const countriesAdapter = ({ data, meta }) => {
  return {
    data: data.map((item) => countryAdapter(item)),
    meta: metaAdapter(meta),
  };
};
